"use client";

/** Send a client-side error to the server log (Admin → Health). Never throws. */
export function reportClientError(error: Error & { digest?: string }, boundary: string, componentStack?: string) {
  try {
    const body = JSON.stringify({
      message: String(error?.message ?? error).slice(0, 2000),
      digest: error?.digest,
      stack: error?.stack?.slice(0, 8000),
      componentStack: componentStack?.slice(0, 8000),
      url: typeof location !== "undefined" ? location.href : undefined,
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
      boundary,
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon("/api/client-errors", new Blob([body], { type: "application/json" }));
    } else {
      void fetch("/api/client-errors", { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
    }
  } catch {
    // Reporting must never break the error screen.
  }
}
